import { Typography } from "@material-ui/core";
import React, { PropsWithChildren } from "react";

export const FormLabel: React.FC<PropsWithChildren<unknown>> = ({ children }) => (
   <Typography style={{ fontSize: "16px", fontWeight: "700", color: "#010440", lineHeight: "23px" }}>
      {children}
   </Typography>
);
